import {
  AppBar,
  Avatar,
  Box,
  Button,
  CardHeader,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useReducer, useRef } from 'react';
import KenGridEditableData from '../../../../global_components/kenEditDataGrid/KenGridEcditableForStudentStatus';

import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import Revulation from './Revulation.js';
import Retest from './Retest';
import KenCard from '../../../../global_components/KenCard';
import { useState } from 'react';
import TablePaginationActions from '../../../../global_components/KenGrid/TablePaginationActions';
import { getRevalData } from '../../../../Utils/apiServices';
import '../../../../style/index.css';
import KenLoader from '../../../../Components/KenLoader';

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  header12: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    marginTop: '30px',
  },
  header1: {
    background: 'transparent',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    height: '28px',
    width: '78px',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  TitleBox: {
    display: 'flex',
    float: 'left',
    margin: '25px 10px',
    padding: '10px',
    background: '#fff',
  },
  TitleTextSpan: {
    fontSize: '16px',
    fontWeight: 'bolder',
    marginLeft: '10px',
  },
  TitleText: {
    fontSize: '10px',
    paddingLeft: '10px',
  },
  view: {
    color: '##272727',

    background: 'rgba(0, 33, 141,0.2)',

    borderRadius: '20px',
    fontSize: '10px',

    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(0, 33, 141,0.2)',

      color: '##272727',
    },
  },
}));

const RevaluationRetest = () => {
  const history = useHistory();
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const arrayBreadCrumb = [
    // { head: 'ADMIN PORTAL', url: routes.adminManagement },
    {
      head: 'EXAM',
      url: 'routes.exam',
    },
    {
      head: 'STUDENT STATUS',
    },
  ];

  const [revalData, setRevalData] = useState([]);

  // Paginations
  const [totalData, setTotalData] = useState(25);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // Pagination is over

  // Data
  const getRevalExamDetailsDataListing = () => {
    setLoading(true);
    getRevalData().then((res) => {
      const ReTestDetailsInfo =
        res === null
          ? []
          : res.map((item, index) => {
              return {
                id: item.id ? item.id : '',
                program: item.courseName ? item.courseName : '',
                course: item.courseName ? item.courseName : '',
                student: item.studentName ? item.studentName : '',
                term: item.termName ? item.termName : '',
                exam_type: item.examType ? item.examType : '',
                exam_date: item.examDate ? item.examDate : '',
                document_submitted: item.documentStatus
                  ? item.documentStatus
                  : '',
                no_of_documents: item.numberofDocuments
                  ? item.numberofDocuments
                  : '',
                revaluation_due_date: item.revalDueDate
                  ? item.revalDueDate
                  : '',
                status: item.status ? item.status : '',
                reason: item.reason ? item.reason : '',
                batch: item.batch ? item.batch : '',
                examCycle: item.examCycle ? item.examCycle : '',
                marks: item.previousMarks ? item.previousMarks : '',
                evalulator: '',
                EvaluatorAssigned: item.EvaluatorAssigned
                  ? item.EvaluatorAssigned
                  : '',
                EvaluatorAssigedId: item.EvaluatorAssigedId
                  ? item.EvaluatorAssigedId
                  : '',
              };
            });
      setLoading(false);

      setRevalData(ReTestDetailsInfo);
    });
  };

  useEffect(() => {
    getRevalExamDetailsDataListing();
  }, []);

  return (
    <Box>
      {loading && <KenLoader />}
      <Box className={classes.breadCrumbWrapper}>
        <BreadCrumb array={arrayBreadCrumb} history={history} />
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            REVALUATION
          </Typography>
        </Toolbar>
      </AppBar>
      <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <Table className={classes.table} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell className="tableHeaderTitle" align="left">
                  PROGRAMS
                </TableCell>

                <TableCell className="tableHeaderTitle" align="left">
                  TERM
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  COURSE
                </TableCell>

                <TableCell className="tableHeaderTitle" align="left">
                  BATCH
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {revalData?.map((row) => (
                <TableRow
                  className="editableTableRowData editableTableRowDatas"
                  key={row.id}
                >
                  {/* <CustomTableCell {...{ row, name: 'name', onChange }} /> */}
                  <KenGridEditableData
                    {...{
                      row,
                      // onChange,
                      columns: [
                        {
                          column_name: 'program',
                          is_inline_edit: false,
                          inline_edit_type: '',
                          label: 'program',
                        },
                        {
                          column_name: 'course',
                          is_inline_edit: false,
                          inline_edit_type: '',
                          label: 'course',
                        },

                        {
                          column_name: 'term',
                          is_inline_edit: false,
                          inline_edit_type: '',
                          label: 'term',
                        },
                        {
                          column_name: 'batch',
                          is_inline_edit: false,
                          inline_edit_type: '',
                          label: 'batch',
                        },
                      ],
                    }}
                  />

                  <TableCell className={classes.selectTableCell}>
                    <Button
                      className={classes.view}
                      // color="primary"
                      size="small"
                      variant="primary"
                    >
                      <Link
                      // to={{
                      //   pathname: `${routes.moderation}/details/${row?.courseName}`,
                      //   state: { gradingId: ele?.courseOfferingId },
                      // }}
                      >
                        View / Edit
                      </Link>
                    </Button>
                  </TableCell>
                </TableRow>
              ))}{' '}
            </TableBody>
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              colSpan={10}
              count={totalData ? totalData : revalData.length}
              page={page}
              rowsPerPage={rowsPerPage}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Table>
        </KenCard>
      </Box>

      {/* <div style={{ marginTop: '50px' }}>
        <AppBar position="static" elevation={0} className={classes.header}>
          <Revulation />
        </AppBar>
      </div>
      <AppBar position="static" elevation={0} className={classes.header12}>
        <Retest />
      </AppBar> */}
    </Box>
  );
};

export default RevaluationRetest;
